import ReactJson from 'react18-json-view'; // https://www.npmjs.com/package/react18-json-view
import 'react18-json-view/src/style.css'

export default ReactJson.default || ReactJson;
